export default __webpack_public_path__ + "static/media/hht2_ep19_timeline_q04_b.4bbf2f04.png";